<template>
  <section>
    <Title :title-name="title.ServiceOptionRefund.titleName" :title-link="title.ServiceOptionRefund.titleLink" />
    <div class="select_service">
      <div class="container" style="padding: 14pt">
        <p>Dear {{ pax.title }}&nbsp;{{ pax.first_name }}&nbsp;{{ pax.last_name }},</p>
        You have chosen for a full refund, for your convenience we have issued a creditcard for you, with the amount of your
        flight.
      </div>
      <div class="block-item">
        <div class="container">
          <h2 class="title" style="font-size: 16pt; width: 100%; margin: 0">Full Refund</h2>
        </div>
      </div>
      <div class="container" style="padding: 14pt">
        <p>
          Your flight booking has been cancelled and a full refund of 123,00 {{ airline.currency_code }} is available for your
          convenience on the below mentioned creditcard. This creditcard has a validation of 6 months and can be used as well as a
          form of payment on our website.
        </p>
        <p>We apologize for the inconvenience caused and hope to see you soon on one of our flights.</p>
        <CreditCard v-if="airline.taxi_enabled === 1"></CreditCard>
      </div>
      <div v-if="airline.taxi_enabled === 1" class="taxi_voucher_download block-item" style="margin-top: 14pt">
        <div class="container">
          <router-link :to="{ name: 'VirtualCreditCardDetail', query: { secret: secret } }">
            <div>
              <AboutCreditCard></AboutCreditCard>
            </div>
          </router-link>
        </div>
      </div>
      <ButtonDownloadVoucher
        v-if="airline.taxi_enabled === 1"
        :name-voucher="nameVoucher"
        :can-download="canDownload"
      ></ButtonDownloadVoucher>
    </div>
  </section>
</template>

<script>
import '@/assets/scss/modules/SelectService.scss'
import CreditCard from '@/components/CreditCard/index'
import AboutCreditCard from '@/components/AboutCreditCard/index'
import ButtonDownloadVoucher from '@/components/ButtonDownloadVoucher/index'
import Title from '@/components/Title/index'
import { replaceStr } from '@/utils/helper'

export default {
  name: 'ServiceOptionRefund',
  components: { ButtonDownloadVoucher, AboutCreditCard, CreditCard, Title },
  props: {
    secret: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      nameVoucher: 'Refund',
      canDownload: false
    }
  },
  watch: {
    airline: function (newVal) {
      this.canDownload = newVal.currency_code != '' ? true : false
    }
  }
}
</script>
